import { Navigate, Outlet } from 'react-router-dom';
import AuthPage from '../../../../pages/AuthPage';
import { STATE_LOGIN, STATE_SIGNUP } from '../../../../components/AuthForm';
const useAuth = () => {
  const user = { loggedIn: false };
  const userInfo = localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null;
  //  console.log("userInfo : ", userInfo);
  return userInfo;
};

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  return isAuth ? <Outlet /> : <AuthPage authState={STATE_LOGIN} />;
};

export default ProtectedRoutes;
